import { useEffect } from 'react';
import TextInput, { ITextInputProps } from './TextInput';

interface ITextInputWithAutoFocusProps extends ITextInputProps {
    inputReference: React.MutableRefObject<HTMLInputElement>;
}

const TextInputWithAutoFocus: React.FC<ITextInputWithAutoFocusProps> = (props) => {
    useEffect(() => {
        if (!props.inputReference.current) {
            return;
        }

        props.inputReference.current.focus();
    }, [props.inputReference]);

    return (
        <div
            ref={(containerRef) => {
                if (!containerRef || !props.inputReference) {
                    return;
                }

                const inputElement = containerRef.querySelector('input') as HTMLInputElement;
                props.inputReference.current = inputElement;
            }}
        >
            <TextInput {...props} />
        </div>
    );
};

export default TextInputWithAutoFocus;
